// extracted by mini-css-extract-plugin
export default {"container":"CoinInfo_container__EGKZK","buttons":"CoinInfo_buttons__5dsmW"};